<div class="sidebar" [ngClass]="sidebarClass">
  <igx-menu [menu]="menu()"></igx-menu>
</div>
